import { render, staticRenderFns } from "./AccumulationPopup.vue?vue&type=template&id=5c014306&"
import script from "./AccumulationPopup.vue?vue&type=script&lang=ts&"
export * from "./AccumulationPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports